import DataGridComponent from "components/DataGridComponent/DataGridComponent"
import { DeleteDialog } from "components/DeleteDialog/DeleteDialog"
import { DataType, DeviceData, DeviceDataGroup } from "graphql/types"
import { useStoreActions } from "hooks/storeHooks"
import { useState } from "react"
import { v4 } from "uuid"
import { AddDeviceDataDialog } from "./AddDeviceDataDialog"

type AdminDeviceDataProps = {
  deviceData: DeviceData[]
  deviceDataGroup: DeviceDataGroup
}

const AdminDeviceData = (props: AdminDeviceDataProps) => {
  const { deviceData, deviceDataGroup } = props

  const { updateDeviceDataGroup } = useStoreActions((actions) => actions)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [formState, setFormState] = useState<DeviceData>({
    id: "",
    name: "",
    dataType: DataType.STRING,
    unit: [],
    isArray: false,
    isCalculation: false,
    isOperatingMode: false,
    data: [],
  })
  const [openDelete, setOpenDelete] = useState(false)
  const [toDelete, setToDelete] = useState<string[]>([])

  const handleEdit = (id: string) => {
    if (id === "NEW") {
      setFormState({
        id: "NEW",
        name: "",
        dataType: DataType.STRING,
        unit: [],
        isArray: false,
        isCalculation: false,
        isOperatingMode: false,
        data: [],
      })
    } else {
      const devData = deviceData.find((tb) => tb.id === id)
      if (devData) {
        setFormState(devData)
      }
    }
    setDialogOpen(true)
  }

  const handleDelete = (id: string[]) => {
    setOpenDelete(true)
    setToDelete(id)
  }

  const handleDeleteSelected = () => {
    if (!deviceDataGroup?.deviceData) {
      console.error("deviceData ist nicht definiert")
      return
    }

    const newGroup = {
      ...deviceDataGroup,
      deviceData: deviceDataGroup.deviceData.filter((config) => !toDelete.includes(config.id)),
    }
    updateDeviceDataGroup(newGroup)
    setToDelete([])
    setOpenDelete(false)
  }

  const handleDialogClose = () => {
    setDialogOpen(false)
  }

  const handleFormSubmit = (arg: DeviceData) => {
    let newGroup = { ...deviceDataGroup }
    if (arg.id === "NEW") {
      newGroup.deviceData = [...deviceDataGroup.deviceData, { ...arg, id: v4() }]
    } else {
      newGroup.deviceData = newGroup.deviceData.map((config) =>
        config.id === arg.id ? arg : config
      )
    }
    updateDeviceDataGroup(newGroup)
    setDialogOpen(false)
  }

  const columns = [
    { field: "name", headerName: "Name", flex: 150 },
    {
      field: "dataType",
      headerName: "Datentyp",
      flex: 150,
      valueFormatter: (params: DataType) => {
        switch (params) {
          case DataType.STRING:
            return "Text"
          case DataType.FLOAT:
            return "Zahl"
          case DataType.BOOLEAN:
            return "Boolean"
          default:
            return params
        }
      },
    },
    {
      field: "unit",
      headerName: "Einheit",
      flex: 150,
      valueGetter: (params: string[]) => params.join(", "),
    },
    {
      field: "isArray",
      headerName: "Mehrfachwerte zulassen",
      valueGetter: (params: boolean) => (params ? "Ja" : "Nein"),
      flex: 100,
    },
    {
      field: "isCalculation",
      headerName: "Kalkulationsrelevant",
      valueGetter: (params: boolean) => (params ? "Ja" : "Nein"),
      flex: 100,
    },
    {
      field: "isOperatingMode",
      headerName: "Betriebszustand",
      valueGetter: (params: boolean) => (params ? "Ja" : "Nein"),
      flex: 100,
    },
  ]

  return (
    <>
      <DataGridComponent
        columns={columns}
        rows={deviceData}
        getRowId={(row) => row.id}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onAdd={() => handleEdit("NEW")}
      />

      <AddDeviceDataDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        formState={formState}
        onSubmit={handleFormSubmit}
      />

      <DeleteDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onDelete={handleDeleteSelected}
      />
    </>
  )
}

export default AdminDeviceData
